var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockOpenedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74359 9.33333C5.78462 9.33333 5 10.1476 5 11.1429V20.1905C5 21.1857 5.78462 22 6.74359 22H17.2051C18.1641 22 18.9487 21.1857 18.9487 20.1905V11.1429C18.9487 10.1476 18.1641 9.33333 17.2051 9.33333H14.9385V7.52381C14.9385 5.98571 16.159 4.71905 17.641 4.71905C19.1231 4.71905 20.3436 5.98571 20.3436 7.52381H22C22 5.03571 20.0385 3 17.641 3C15.2436 3 13.2821 5.03571 13.2821 7.52381V9.33333H6.74359ZM11.9744 17.4762C11.0154 17.4762 10.2308 16.6619 10.2308 15.6667C10.2308 14.6714 11.0154 13.8571 11.9744 13.8571C12.9333 13.8571 13.7179 14.6714 13.7179 15.6667C13.7179 16.6619 12.9333 17.4762 11.9744 17.4762Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenedIcon);
export default __webpack_public_path__ + "static/media/lock-opened-icon.b8566903.svg";
export { ForwardRef as ReactComponent };